<template>
  <div>
    <router-view/>
    <fullScreenLoadingView></fullScreenLoadingView>
  </div>
</template>
<script>
import fullScreenLoadingView from '@/views/components/fullScreenLoadingView.vue'
import { initializeApp } from "firebase/app";
import { getMessaging , getToken } from "firebase/messaging";
export default {
  name: 'App',
  data(){
    return {
      
    }
  },
  watch: {
    $route(to, from) {
      // 這裡可以監聽到路由的變化
      console.log('Route changed from', from, 'to', to);
      // 在這裡執行你想要的操作
      if (
        to.matched[1] &&
        to.matched[1].name
      ) {
        this.$store.state.nowPage = to.matched[1].name
      }
    },
  },
  components: { fullScreenLoadingView },
  methods:{},
  mounted(){
    //處理判斷是否登入
    if ( !this.$store.state.loginStatus ){
      console.log('this.$router=',this.$route)
      console.log('this.$router.name=',this.$route.name)
      if ( this.$route.name == "his" ){
        console.log(JSON.stringify(this.$route))
        localStorage.setItem('hisRedirection',JSON.stringify(this.$route))
      }
      setTimeout(()=>{
        this.$router.push('/login')
      },100)
    // }else{
    //   this.$router.push('/main')
    }

  },
  async created(){
    //檢查是否曾經登入
    if (localStorage.getItem('auu_user_info')){
      const res = JSON.parse( localStorage.getItem('auu_user_info') )
      console.log('res:',res)
      this.$api.init({token:res.token})
      this.$store.state.loginStatus = true
    }
    const firebaseConfig = {
      apiKey: "AIzaSyCp2GUONtRBC-SY-ipfhsxiGEBKHVkqdJI",
      authDomain: "auu-test.firebaseapp.com",
      projectId: "auu-test",
      storageBucket: "auu-test.appspot.com",
      messagingSenderId: "599072468855",
      appId: "1:599072468855:web:70609e834d1623c829bb72",
      measurementId: "G-KP7BCKD4BJ"
    };

    const firebaseApp = initializeApp(firebaseConfig);
    const messaging = getMessaging(firebaseApp);
    // Register the service worker
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register(`${process.env.VUE_APP_BASE_PUBLIC_PATH}firebase-messaging-sw.js`)
        .then((registration) => {
            console.log('Service Worker registered with scope:', registration.scope);
            // Request permission and get token
            getToken(messaging, { vapidKey: 'BOuoF6QrweGJ_TeXCJLrozkjGMZ18yK1IQKhFSA5LeMU-o4dp7WCjoC5Zk_2T8qriv227Pjm3cDoJUhrhhtzkCE' }).then((currentToken) => {
                if (currentToken) {
                  console.log('FCM Token:', currentToken);
                } else {
                  console.log('No registration token available. Request permission to generate one.');
                }
            }).catch((err) => {
                console.log('An error occurred while retrieving token. ', err);
            });

        }).catch((err) => {
            console.log('Service Worker registration failed:', err);
        });
    }

    //
  }
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
